/**
 * PATH: packages/job-hub/src/jobs/tabs/job-qa/itp-export/useQaItpPreviewRemove.ts
 * FILE_ID: JOBHUB-QA-ITP-PREVIEW-REMOVE-HOOK-001
 * PURPOSE: Clear the saved ITP cover after the preview cross is confirmed.
 */
export function useQaItpPreviewRemove({
  clearCover,
  patchCover,
  reportError,
}: {
  clearCover: () => Promise<string | null>
  patchCover: (url: string | null) => void
  reportError: (err: unknown) => void
}) {
  const removeSavedCover = async (): Promise<boolean> => {
    try {
      // Reused from: packages/job-hub/src/jobs/tabs/job-qa/useInspectionRecordSettings.ts (clearCover)
      const url = await clearCover()
      // Reused from: packages/job-hub/src/jobs/qa/patchItpCover.ts (patchItpCoverImage)
      patchCover(url)
      return true
    } catch (err) {
      reportError(err)
      return false
    }
  }
  return { removeSavedCover }
}
